// Small array/Map helpers — replace the global Array/Map.prototype monkey-patches
// that used to live (as an import side effect) at the top of KeyBoard.js. Named,
// explicit, no prototype pollution, no hidden import-order coupling.

export const last = (arr) => arr[arr.length - 1];
// Indices for an Array, keys for a Map. ([...x.keys()] does both.)
export const keysOf = (x) => [...x.keys()];
export const kmap = (x, f) => [...x.keys()].map(f);
